webpackJsonp([5,17],{

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ListSkus',
	  props: ['parent', 'parentId', 'filters'],
	  data: function data() {
	    return {
	      skus: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    user: function user(state) {
	      return state.user;
	    },
	    city: function city(state) {
	      return state.city;
	    }
	  })),
	  mounted: function mounted() {
	    this.load();
	  },
	
	  watch: {
	    filters: function filters(newFilters) {
	      this.filter = newFilters;
	      this.load();
	    }
	  },
	  methods: (0, _extends3.default)({
	    getRouteParams: function getRouteParams(sku) {
	      var routeData = {};
	      routeData = {
	        name: 'sku',
	        params: {
	          categorySlug: sku.product.subcategory.category.slug,
	          subcategorySlug: sku.product.subcategory.slug,
	          productSlug: sku.product.slug,
	          skuSlug: sku.slug,
	          skuId: sku.id
	        }
	      };
	      return routeData;
	    },
	    load: function load() {
	      var _this = this;
	
	      var city = this.city ? '&city_id=' + this.city.id : '';
	      var filters = this.filters ? '&filters=' + _lodash2.default.join(this.filters, '_') : '';
	      var uri = '?parent=' + this.parent + '&id=' + this.parentId + city + filters;
	      this.skus = false;
	      this.$http.get('skus' + uri).then(function (response) {
	        _this.skus = response.data.data;
	        _this.$emit('loaded', 'skus');
	      });
	    }
	  }, (0, _vuex.mapActions)([]))
	};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(26)
	
	/* template */
	var __vue_template__ = __webpack_require__(43)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-skus"
	  }, [(!_vm.skus) ? _c('loading') : _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.skus), function(sku) {
	    return _c('div', {
	      staticClass: "col-sm-6 col-md-4",
	      class: {
	        'col-lg-3': _vm.parent == 'catalog'
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": _vm.getRouteParams(sku),
	        "id": 'sku-' + sku.id
	      }
	    }, [_c('div', {
	      staticClass: "product-catalog-item with-prices"
	    }, [_c('div', {
	      staticClass: "chevron visible-xs"
	    }, [_c('i', {
	      staticClass: "fa fa-angle-right fa-3x"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "img-container"
	    }, [_c('img', {
	      staticClass: "img-responsive-center",
	      attrs: {
	        "src": sku.image,
	        "alt": sku.title + ' - Loca.Shop'
	      }
	    })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(sku.title))]), _vm._v(" "), _c('p', [(parseInt(sku.quantity_companies) == 1) ? [_vm._v("Em "), _c('b', [_vm._v(_vm._s(sku.unique_company))]), _vm._v(" por:")] : [_vm._v("Em "), _c('b', [_vm._v(_vm._s(sku.quantity_companies) + " locadoras")]), _vm._v(" a partir de:")]], 2), _vm._v(" "), _c('p', {
	      staticClass: "prices"
	    }, [(sku.price_day > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_day)))]), _vm._v(" "), _c('small', [_vm._v("por dia")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_week > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_week)))]), _vm._v(" "), _c('small', [_vm._v("por semana")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_biweek > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_biweek)))]), _vm._v(" "), _c('small', [_vm._v("por quinzena")]), _c('br')] : _vm._e(), _vm._v(" "), (sku.price_month > 0) ? [_c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(_vm._s(_vm._f("money")(sku.price_month)))]), _vm._v(" "), _c('small', [_vm._v("por mês")])] : _vm._e()], 2)])])], 1)
	  }), 0)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ListSkus = __webpack_require__(41);
	
	var _ListSkus2 = _interopRequireDefault(_ListSkus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PageProduct',
	  components: { ListSkus: _ListSkus2.default },
	  data: function data() {
	    return {
	      product: false,
	      characteristics: false,
	      productId: this.$route.params.productId,
	      filters: this.$route.query.filters || [],
	      tagInterval: false,
	      loaded: {
	        skus: false,
	        product: false
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    user: function user(state) {
	      return state.user;
	    }
	  })),
	  mounted: function mounted() {
	    this.getProduct();
	  },
	  beforeDestroy: function beforeDestroy() {},
	
	  methods: (0, _extends3.default)({
	    getRouteParams: function getRouteParams(params) {
	      return {
	        name: 'subcategory',
	        params: {
	          categorySlug: this.product.subcategory.category.slug,
	          subcategorySlug: this.product.subcategory.slug,
	          subcategoryId: this.product.subcategory.id
	        }
	      };
	    },
	    applyFilter: function applyFilter(id, value) {
	      var params = {
	        name: 'product',
	        params: {
	          productSlug: this.product.slug,
	          productId: this.product.id
	        },
	        query: {}
	      };
	      if (this.companyId) params.query.company_id = this.companyId;
	      params.query.filters = _lodash2.default.join(this.filters, '_');
	      this.$router.push(params);
	    },
	    getProduct: function getProduct() {
	      var _this = this;
	
	      this.loadProduct({ id: this.productId, with: 'subcategory,characteristics' }).then(function (response) {
	        _this.product = response.data;
	        if (_this.$route.query.filters) {
	          _this.filters = _lodash2.default.split(_this.$route.query.filters, '_');
	        }
	        _this.loadedEvent('product');
	      }, function (response) {
	        console.log('error: Loading product resource from API');
	      });
	    },
	    loadedEvent: function loadedEvent(type) {
	      if (type === 'skus') this.loaded.skus = true;
	      if (type === 'product') this.loaded.product = true;
	    }
	  }, (0, _vuex.mapActions)(['loadProduct']))
	};

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(160)
	
	/* template */
	var __vue_template__ = __webpack_require__(301)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-product"
	  }, [_c('div', {
	    staticClass: "space-20"
	  }), _vm._v(" "), (!_vm.loaded.skus || !_vm.loaded.product) ? _c('loading') : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loaded.skus && _vm.loaded.product),
	      expression: "loaded.skus && loaded.product"
	    }],
	    staticClass: "container"
	  }, [(_vm.product) ? _c('p', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("Catálogo")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-double-right"
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": _vm.getRouteParams()
	    }
	  }, [_vm._v(_vm._s(_vm.product.subcategory.name))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-double-right"
	  }), _vm._v(" " + _vm._s(_vm.product.name) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('ul', {
	    staticClass: "list-group characteristics"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.product.characteristics), function(char) {
	    return _c('li', {
	      staticClass: "list-group-item"
	    }, [_c('h4', {
	      staticClass: "list-group-item-heading"
	    }, [_vm._v(_vm._s(char.name))]), _vm._v(" "), _c('div', {
	      staticClass: "list-group-item-text"
	    }, _vm._l((char.values), function(qnt, value) {
	      return _c('div', {
	        staticClass: "checkbox"
	      }, [_c('span', {
	        staticClass: "badge"
	      }, [_vm._v(_vm._s(qnt))]), _vm._v(" "), _c('label', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.filters),
	          expression: "filters"
	        }],
	        attrs: {
	          "name": "filters",
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": char.id + '-' + value,
	          "checked": Array.isArray(_vm.filters) ? _vm._i(_vm.filters, char.id + '-' + value) > -1 : (_vm.filters)
	        },
	        on: {
	          "change": [function($event) {
	            var $$a = _vm.filters,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = char.id + '-' + value,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (_vm.filters = $$a.concat([$$v]))
	              } else {
	                $$i > -1 && (_vm.filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.filters = $$c
	            }
	          }, function($event) {
	            return _vm.applyFilter(char.id, value)
	          }]
	        }
	      }), _vm._v(" " + _vm._s(value) + " " + _vm._s(char.unit) + "\n                ")])])
	    }), 0)])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('list-skus', {
	    attrs: {
	      "parent": "product",
	      "parent-id": _vm.productId,
	      "filters": _vm.filters
	    },
	    on: {
	      "loaded": _vm.loadedEvent
	    }
	  })], 1)])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-group-item"
	  }, [_c('label', {
	    staticClass: "no-margin"
	  }, [_vm._v("FILTROS")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.e2e8b872bd2f3587bc5f.js